export default "__VITE_ASSET__Ba4S5_Xl__"